import { Component, OnInit } from '@angular/core';
import { CicoHelpConfigurationService } from '../shared/cico-help-configuration.service';
import { MimeTypeUtils } from '../../shared/mime-type-utils';
import { CicoHelpConfigurationFile } from '../shared/cico-help-configuration-file.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-cico-help-configuration',
  templateUrl: './cico-help-configuration.component.html',
  styleUrls: ['./cico-help-configuration.component.scss']
})
export class CicoHelpConfigurationComponent implements OnInit {

  currentFile: CicoHelpConfigurationFile = null;
  pendingFile: File = null;

  currentFileType: string;

  acceptedFileExtensions = ['.png', '.jpeg', '.jpg'];
  acceptedFileTypes = [
    MimeTypeUtils.getMimeTypeByExtension('png'),
    MimeTypeUtils.getMimeTypeByExtension('jpeg'),
    MimeTypeUtils.getMimeTypeByExtension('jpg')
  ];

  constructor(
    private cicoHelpService: CicoHelpConfigurationService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.cicoHelpService.downloadFile()
      .subscribe((file) => {
        this.sanitizer.bypassSecurityTrustResourceUrl(file.downloadUrl)
        this.currentFile = file
        this.currentFileType = MimeTypeUtils.getMimeTypeByFilename(file.filename);
      });
  }

  uploadFile(): void {
    this.cicoHelpService.uploadFile(this.pendingFile)
      .subscribe((file) => {
        this.sanitizer.bypassSecurityTrustResourceUrl(file.downloadUrl)
        this.currentFile = file;
        this.currentFileType = MimeTypeUtils.getMimeTypeByFilename(file.filename);
        this.resetPendingFile();
      });
  }

  resetPendingFile() {
    this.pendingFile = null;
  }
}
